'use strict';

var React = require('react');
var _ = require('lodash');
//Components
var PersonalInfo = require('./PersonalInfo.jsx');
var ContactDetails = require('./ContactDetails.jsx');
var Tfn = require('../Common/Tfn.jsx');
var Occupation = require('./Occupation.jsx');
var Address = require('./Address.jsx');
var Residence = require('./Residence.jsx');
var UserNotification = require('../Common/UserNotification.jsx');
var Formatter = require('../../utils/Formatter.js');
var PowerOfAttorney = require('./PowerOfAttorney.jsx').default;
//Stores
var YourDetailsStore = require('../../stores/YourDetailsStore');
//Contents
var YourDetailsConstants = require('../../constants/YourDetailsConstants.js');

function getStateFromStores() {
    return {
        titleList: YourDetailsStore.getTitleList(),
        addressInfo: YourDetailsStore.getAddressInfo(),
        isLessThan60: YourDetailsStore.getIsAgeLessThan60(),
        errorList: YourDetailsStore.getErrorList(),
        accountType: YourDetailsStore.getAccountType(),
        tfnExemptionList: YourDetailsStore.getTfnExemptionList(),
        yourDetailsData: YourDetailsStore.getYourDetailsData(),
        crossSectionDependencyMsg: YourDetailsStore.getCrossSectionDependencyMsg(),
        isUserNotificationClosed: false
    };
}

var Pension = React.createClass({

    getInitialState: function () {
        return getStateFromStores();
    },

    // Add change listeners to stores
    componentDidMount: function () {
        YourDetailsStore.addChangeListener(this._onChange);
    },

    // Remove change listers from stores
    componentWillUnmount: function () {
        YourDetailsStore.removeChangeListener(this._onChange);
    },

    _onChange: function () {
        this.setState(getStateFromStores());
    },

    getCrossSectionMsg: function () {
        var crossSectionMsg = Formatter.formatString(this.props.content.crossSectionParentText, { parentSection: this.props.content.yourDetails.sectionHeader, sections: _.pluck(this.state.crossSectionDependencyMsg, 'content').join(', ') });

        return crossSectionMsg;
    },

    toggleUserNotificationClose: function () {
        this.setState({ isUserNotificationClosed: true, crossSectionDependencyMsg: this.state.crossSectionDependencyMsg.splice(0, this.state.crossSectionDependencyMsg.length) });
    },

    render: function () {
        return (
                <div>
                    <UserNotification id="yourDetailsPensionUserNotification"
                        message={this.getCrossSectionMsg()}
                        onClick={this.toggleUserNotificationClose}
                        isHidden={!this.state.crossSectionDependencyMsg.length || this.state.isUserNotificationClosed} />
                    <PersonalInfo data={this.state.yourDetailsData}
                                  titleList={this.state.titleList}
                                  errorList={this.state.errorList} />
                    <Address data={this.state.addressInfo}
                             errorList={this.state.errorList}
                             productId={this.props.productId} />
                    <ContactDetails productId={this.props.productId}
                                    accountType={this.props.accountType}
                                    data={this.state.yourDetailsData}
                                    errorList={this.state.errorList} />
                    <Tfn productId={this.props.productId}
                         accountType={this.props.accountType}
                         tfnNumberIsMandatory={false}
                         hasTfnExemption={this.state.yourDetailsData.hasTfnExemption}
                         hasTfnExemptionReadonly={this.state.yourDetailsData.hasTfnExemptionReadonly}
                         tfnNumber={this.state.yourDetailsData.tfnNumber}
                         tfnNumberReadonly={this.state.yourDetailsData.tfnNumberReadonly}
                         tfnExemptionList={this.state.tfnExemptionList}
                         tfnConsentFlag={this.state.yourDetailsData.tfnConsentFlag}
                         tfnWithConsent={this.state.yourDetailsData.tfnWithConsent}
                         underAge60={this.state.isLessThan60}
                         errorList={this.state.errorList} />
                    <Residence data={this.state.yourDetailsData}
                               type={YourDetailsConstants.ResidenceType.COUNTRY_RESIDENCE}
                               countryLabel="What is your main country of residence?"
                               errorList={this.state.errorList}
                               showQuestion={!this.state.yourDetailsData.countryOfResidenceReadonly} />
                    <Residence data={this.state.yourDetailsData}
                               type={YourDetailsConstants.ResidenceType.TAX_RESIDENCE}
                               countryLabel="What is your country of residence for tax purposes?"
                               errorList={this.state.errorList}
                               showQuestion={false} />
                    <Occupation data={this.state.yourDetailsData}
                                productId={this.props.productId}
                                errorList={this.state.errorList} />
                    <PowerOfAttorney data={this.state.yourDetailsData.isPowerOfAttorney} />
                </div>
        );
    }
});

module.exports = Pension;


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./components/YourDetails/Pension.jsx